var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"SitesOverview"}},[_c('h1',[_vm._v(_vm._s(_vm.$tc('views.nd.netdoc.sites', 2)))]),_c('LoadingPlaceholder',{attrs:{"data":_vm.sites}},[_c('SiteList',{attrs:{"sites":_vm.sites,"site_types":_vm.site_types}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }